<template>
  <div>
    <routes></routes>
  </div>
</template>

<script setup lang="ts">
import Routes from '@/components/doc-type-routes/Routes.vue'

defineOptions({
  name: 'Routes',
})
</script>
